import { Release } from '../types';
import { RecursiveStringifyEnums } from './buildDistro';
import { baseRelease } from '@/testData/baseRelease';

export const baseReleaseiOS = () => {
    const release: RecursiveStringifyEnums<Release> = {
        ...baseRelease(),
        phasedRelease: {
            dayNumber: 0,
            isManuallyAcceleratedPhasedRollout: false,
            isRunwayAcceleratedRollout: false,
            isRunwayPaused: false,
            startDate: null,
            state: 'INACTIVE',
            userFraction: 0,
            blackoutEndsAt: '2024-05-10T13:33:32.988339868-07:00',
            changedByAutomation: null,
            completedAt: null,
            isOnBlackoutPeriod: false,
            phasedReleasePercent: 0,
            isSuperseded: false,
        },
        doesBranchExist: true,
        releasedAt: null,
        createdOrigin: 'runwayDraft',
        isKickedOff: true,
        nextVersion: '3.98.0',
        scheduledAutomationsPaused: null,
        isReleaseTagged: false,
        isSubmitted: false,
        isReleased: false,
        overview: {
            totalAutomationsPerformedCount: 0,
            totalAutomationsScheduledCount: 0,
            estimatedAutomationsCostSaving: 0,
            estimatedAutomationsTimeSaved: 0,
            codeContributors: [
                {
                    id: '1',
                    firstName: 'Sully',
                    lastName: 'Sullenberger',
                    email: 'sully@demo.com',
                    avatar: 'https://robohash.org/enimperspiciatisvitae.png?size=50x50&set=set1',
                    itemOfWorkCount: 45,
                },
                {
                    id: '2',
                    firstName: 'Lukas',
                    lastName: 'McMorland',
                    email: 'lmcmorland1@example.com',
                    avatar: 'https://robohash.org/quoprovidenthic.png?size=50x50&set=set1',
                    itemOfWorkCount: 23,
                },
                {
                    id: '3',
                    firstName: 'Manon',
                    lastName: 'Willan',
                    email: 'mwillan2@example.com',
                    avatar: 'https://robohash.org/enimperspiciatisvitae.png?size=50x50&set=set1',
                    itemOfWorkCount: 18,
                },
                {
                    id: '4',
                    firstName: 'Sibeal',
                    lastName: 'Neward',
                    email: 'sneward3@example.com',
                    avatar: 'https://robohash.org/vitaefugiatsimilique.png?size=50x50&set=set1',
                    itemOfWorkCount: 42,
                },
                {
                    id: '5',
                    firstName: 'Hagen',
                    lastName: 'Coolican',
                    email: 'hcoolican4@example.com',
                    avatar: 'https://robohash.org/quiquosed.png?size=50x50&set=set1',
                    itemOfWorkCount: 38,
                },
                {
                    id: '6',
                    firstName: 'Eada',
                    lastName: 'Benyan',
                    email: 'ebenyan5@example.com',
                    avatar: 'https://robohash.org/consequuntursimiliquequo.png?size=50x50&set=set1',
                    itemOfWorkCount: 14,
                },
                {
                    id: '7',
                    firstName: 'Bobinette',
                    lastName: 'Herkess',
                    email: 'bherkess6@example.com',
                    avatar: 'https://robohash.org/uttemporibusea.png?size=50x50&set=set1',
                    itemOfWorkCount: 1,
                },
                {
                    id: '8',
                    firstName: 'Asa',
                    lastName: 'Macak',
                    email: 'amacak7@example.com',
                    avatar: 'https://robohash.org/commodivoluptatibusmolestiae.png?size=50x50&set=set1',
                    itemOfWorkCount: 17,
                },
                {
                    id: '9',
                    firstName: 'Hewie',
                    lastName: 'Rawdall',
                    email: 'hrawdall8@example.com',
                    avatar: 'https://robohash.org/quibusdamliberofugiat.png?size=50x50&set=set1',
                    itemOfWorkCount: 2,
                },
                {
                    id: '10',
                    firstName: 'Mona',
                    lastName: 'Lumb',
                    email: 'mlumb9@example.com',
                    avatar: 'https://robohash.org/namcorruptinobis.png?size=50x50&set=set1',
                    itemOfWorkCount: 1,
                },
                {
                    id: '11',
                    firstName: 'Eada',
                    lastName: 'Benyan',
                    email: 'ebenyan5@example.com',
                    avatar: 'https://robohash.org/consequuntursimiliquequo.png?size=50x50&set=set1',
                    itemOfWorkCount: 1,
                },
                {
                    id: '12',
                    firstName: 'Bobinette',
                    lastName: 'Herkess',
                    email: 'bherkess6@example.com',
                    avatar: 'https://robohash.org/uttemporibusea.png?size=50x50&set=set1',
                    itemOfWorkCount: 1,
                },
                {
                    id: '13',
                    firstName: 'Asa',
                    lastName: 'Macak',
                    email: 'amacak7@example.com',
                    avatar: 'https://robohash.org/commodivoluptatibusmolestiae.png?size=50x50&set=set1',
                    itemOfWorkCount: 7,
                },
                {
                    id: '14',
                    firstName: 'Hewie',
                    lastName: 'Rawdall',
                    email: 'hrawdall8@example.com',
                    avatar: 'https://robohash.org/quibusdamliberofugiat.png?size=50x50&set=set1',
                    itemOfWorkCount: 2,
                },
                {
                    id: '15',
                    firstName: 'Mona',
                    lastName: 'Lumb',
                    email: 'mlumb9@example.edu',
                    avatar: 'https://robohash.org/namcorruptinobis.png?size=50x50&set=set1',
                    itemOfWorkCount: 11,
                },
            ],
            contributingTeams: [
                { name: 'analytics', itemOfWorkCount: 8 },
                { name: 'infra', itemOfWorkCount: 1 },
                { name: 'launch', itemOfWorkCount: 10 },
                { name: 'api', itemOfWorkCount: 13 },
                { name: 'ux', itemOfWorkCount: 3 },
            ],
            topChangedFiles: [
                {
                    fileName: 'ContentView.swift',
                    linesChangedCount: 47,
                    isConfigFile: false,
                },
                {
                    fileName: 'FancyMenu.swift',
                    linesChangedCount: 32,
                    isConfigFile: false,
                },
                {
                    fileName: 'Assets.xcassets',
                    linesChangedCount: 12,
                    isConfigFile: false,
                },
            ],
            totalFilesChanged: 151,
            averageAppStoreCrashFreeSessions: 0,
            averageAppStoreCrashFreeUsers: 0,
            averageBetaCrashFreeSessions: 0,
            averageBetaCrashFreeUsers: 0,
        },
    };
    return release;
};
